import React from 'react';
import proptypes from 'prop-types';
import Footer from '@glowforge/ui-common/components/footer/footer';
import getContentfulGlobalFooterProps from '@glowforge/ui-common/models/footer';

const FooterSection = ({ footerContent }) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <Footer {...getContentfulGlobalFooterProps(footerContent)} />
);

FooterSection.propTypes = {
  footerContent: proptypes.shape({}).isRequired,
};

export default FooterSection;
